export const module = {
  info: {
    name: 'voip-fusion-server',
    caption: 'voip fusion server',
    viewGroup: 'general-modules'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,
  sideMenu: {
    topSeparator: false,
    caption: 'FusionPBX Servers',
    icon: 'el-icon-cpu',
    routeName: 'module->voip-fusion-server->create',
    children: [
      {
        caption: 'Create Server',
        icon: 'el-icon-plus',
        routeName: 'module->voip-fusion-server->create'
      },
      {
        caption: 'List Servers',
        icon: 'el-icon-more-outline',
        routeName: 'module->voip-fusion-server->list'
      }
    ]
  }
}

export default module
